window.arDocumentsStatusClientCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        classes: row.status_client_cell_style
    };
};
